<template>
  <div style="overflow: hidden;">
    <img
      class="preImage"
      v-for="(item, index) in singleReceiptImgList"
      :key="index"
      :src="item.src"
      @click="showImg(index)"
    />
    <previewer :list="singleReceiptImgList" ref="previewer"></previewer>
    <div class="submitButton" @click="goUserFrame()">同意</div>
  </div>
</template>

<script>
import { Previewer } from "vux";
import { templateDetail } from "../../api/frame";
export default {
  name: "templateDetail",
  components: {
    Previewer
  },
  data() {
    return {
      singleReceiptImgList: []
    };
  },
  created() {
    this.getTemplate();
  },
  methods: {
    showImg(index) {
      this.$refs.previewer.show(index);
    },
    getTemplate() {
      templateDetail({ code: "oilFrameworkProtocol" })
        .then(res => {
          this.singleReceiptImgList.push({
            src: res.templateUrl,
            msrc: res.templateUrl
          });
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    goUserFrame() {
      this.$router.push("/user/userFrame");
    }
  }
};
</script>

<style scoped>
.submitButton {
  height: 88px;
  line-height: 88px;
  text-align: center;
  color: #fff;
  background-color: #007bec;
  font-size: 15px;
  margin: 70px 20px;
  border-radius: 10px;
}
.preImage {
  width: 100%;
  height: 100%;
  display: block;
}
</style>
